import React from 'react';

import {connect} from 'react-redux';
import {tooltip} from '../services/message.service';

/**
 * creer une button pour copier contenu
 *
 * @param messages Array de messages du store
 */

// generer la description de la piece
function getDescription(index) {
    let childrens = []
    const parent = document.getElementsByClassName("Description");
    if (parent.length > 0) {
      // ajouter les desriptions
      const children = parent[index]?.children || [];
      for (let j = 0; j < children.length; j++) {
        if (!Array.from(children[j].classList).includes("quantity")) {
          childrens.push((children[j].textContent.replace(/\n{2,}/g, '\n') || children[j].innerText).trim())
        }
      }
    }
    return childrens.length > 0 ? childrens.join("\n") : ""
  }
  


function CopyButtonComponent({messages, type}) {
  const svgValid = `
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#474d52" class="size-6">
      <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75"/>
    </svg> 
  `;
  const handleClick = (e, index, messageType = "success") => {
    const message = messages.find(m=> m.key === "config3d_message_copied_description")
    //la description à copier
    let contenu = getDescription(index)
  
    // Créer un élément temporaire pour la copie
    let tempElement = document.createElement("textarea");
    tempElement.value = contenu;
    document.body.appendChild(tempElement);
  
    // Sélectionner et copier le contenu
    tempElement.select();
    document.execCommand("copy");
  
    // Supprimer l'élément temporaire
    document.body.removeChild(tempElement);
  
    // Afficher message de confirmation
    tooltip(messageType, message && message.value ? message.value : "La description copiée !")
    e.stopPropagation()
    e.preventDefault()
  }
  return (
    <button className= "copy-link" onClick={e => handleClick(e, type)}><span className='copy-img' dangerouslySetInnerHTML={{ __html: svgValid }}></span></button>
    )
}

export const CopyButton = connect((state) => ({
    messages: state.ui.messagesList
  })
)(CopyButtonComponent);

